let lenisInstance = null;

export const setLenisInstance = (instance) => {
  lenisInstance = instance;
};

export const scrollToSection = (id) => {
  const target = document.getElementById(id);
  if (!target) return;
  if (lenisInstance) {
    lenisInstance.scrollTo(target, { offset: -72, duration: 1.1 });
  } else {
    target.scrollIntoView({ behavior: "smooth", block: "start" });
  }
};

export const scrollToTop = () => {
  if (lenisInstance) {
    lenisInstance.scrollTo(0, { duration: 1.1 });
  } else {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }
};
